var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.8333 11.75V27.4167C54.8333 28.4554 55.246 29.4517 55.9805 30.1862C56.715 30.9207 57.7112 31.3333 58.75 31.3333H74.4167",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5833 82.25H27.4167C25.3391 82.25 23.3467 81.4247 21.8777 79.9557C20.4086 78.4866 19.5833 76.4942 19.5833 74.4167V19.5833C19.5833 17.5058 20.4086 15.5134 21.8777 14.0443C23.3467 12.5753 25.3391 11.75 27.4167 11.75H54.8333L74.4167 31.3333V74.4167C74.4167 76.4942 73.5914 78.4866 72.1223 79.9557C70.6533 81.4247 68.6609 82.25 66.5833 82.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 43.0834V66.5834",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2083 52.875L47 43.0834L56.7917 52.875",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon2);
export default __webpack_public_path__ + "static/media/file-icon-2.d0dc328343e2946863d1b4b11f9b5f0a.svg";
export { ForwardRef as ReactComponent };